export const digitUtil = (num = 0, digit) => {
    let dig = Math.pow(10, digit)
    num = Math.round(parseFloat(num) * dig) / dig;


    let suffix = "."
    if (num.toString().indexOf(".") < 0) {
        for (let i = 0; i < digit; i++) {
            suffix = suffix + "0"
        }
        num = num.toString() + suffix;
    } else {
        let numSplit = num.toString().split('.')
        let suffixLength = digit - numSplit[1].length
        suffix = suffix + numSplit[1]
        for (let i = 0; i < suffixLength; i++) {
            suffix = suffix + "0"
        }
        num = numSplit[0] + suffix;
    }
    return num
}